module.exports = __webpack_public_path__ + "media/images/pattern-a6008ef7049e23bf40e6060f71e5d6c9.svg";